require('./bootstrap');
require('video.js');
require('@filmgardi/videojs-markers');
require('slick-slider')

import videojs        from "video.js";
import videojsYoutube from "videojs-youtube";
import Alpine  from 'alpinejs';

$(document).ready(function(){
    $('.posts__list').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        nextArrow: '<div class="next-arrow"></div>',
        prevArrow: '<div class="prev-arrow"></div>',
        infinite: false,
        responsive: [
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 700,
                settings: {
                    slidesToShow: 1.085,
                }
            },
        ]
    });

    $('.to-top').click(function (){
        $("html, body, #app").animate({ scrollTop: 0 }, "slow");
        return false;
    })

    $('.cookie__agree').click(function (){
        document.cookie = "cookieAgree=true; path=/; expires=Tue, 19 Jan 2048 03:14:07 GMT";
        $('.cookie').remove();
    })

    $('.tabs__nav__item').click(function (){
        if (!$(this).hasClass('active')) {
            $('.tabs__nav__item').removeClass('active')
            $(this).addClass('active')
            let tab = $(this).attr('data-for-tab');
            $('.tabs__content__item').removeClass('active')
            $(`.tabs__content__item[data-tab="${tab}"]`).addClass('active')

            if ($('.login-page')) {
                if (history.pushState) {
                    var baseUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
                    var newUrl = baseUrl + '?tab='+tab;
                    history.pushState(null, null, newUrl);
                }
            }
        }
    })

    $('.form-row__field.password .show-password').click(function (){
        let input = $(this).parent('.form-row__field').find('input')
        if ($(this).hasClass('showed')) {
            $(this).removeClass('showed')
            input.attr('type', 'password')
        } else {
            $(this).addClass('showed')
            input.attr('type', 'text')
        }
    })

    $('.form-row').each(function () {
        if($(this).find('.form-row__error').length) {
            $(this).addClass('has-error')
        }
    })

    if(!getCookie('cookieAgree')) {
        $('.cookie').show(0)
    }

    let initSlider = false;
    
    $('.team__list').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        nextArrow: '<div class="next-arrow"></div>',
        prevArrow: '<div class="prev-arrow"></div>',
        infinite: false,
        responsive: [
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 700,
                settings: {
                    slidesToShow: 1.085,
                    variableWidth: true,
                }
            },
        ]
    });
    

    $(window).resize(function (){
        if ($(window).width() <= 700) {
            initSlider = true;
            $('.team__list').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                nextArrow: '<div class="next-arrow"></div>',
                prevArrow: '<div class="prev-arrow"></div>',
                infinite: false,
                variableWidth: true,
            });
        } else if (initSlider) {
            $('.team__list').filter('.slick-initialized').slick('unslick');
            initSlider = false;
        }
    })

    // Отображение тултипа при клике
    $('.hidden-tags').on('click', function (e) {
        e.stopPropagation(); // Остановка всплытия
        $(this).find('.tooltip').toggle(); // Показать/скрыть тултип
    });

    // Скрытие тултипа при клике вне его
    $(document).on('click', function () {
        $('.tooltip').hide();
    });

    $('.tabs__nav .tabs__nav__item:first').addClass('active');
    $('.tabs__content__item:first').addClass('active');

});


$('.show-more__title').click(function (){
    let parent = $(this).parent();
    parent.find('.show-more__content').slideToggle(500);
})

function getCookie(name) {
    let matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

let dropdown = $('.dropdown'),
    dropdownBtn = dropdown.find('.dropdown-btn');

dropdownBtn.click(function (){
    let parent = $(this).parent();
    parent.toggleClass('active');
    parent.find('.dropdown-menu').toggleClass('show');
})
$('.dropdown-menu__close').click(function (){
    $('.dropdown.active').removeClass('active');
    dropdown.find('.dropdown-menu').removeClass('show');
})
$('.content__search__filter-btn').click(function (){
    $('.library__filter').addClass('active-mobile');
})
$('.library__filter__close').click(function (){
    $('.library__filter').removeClass('active-mobile');
})



$(document).click(function(event) {
    var $target = $(event.target);
    if(!$target.closest('.dropdown').length && $('.dropdown.active')) {
        $('.dropdown.active').removeClass('active');
        dropdown.find('.dropdown-menu').removeClass('show');
    }
    if((!$target.closest('.popup__content').length) && $('.popup.show').length) {
        $('.popup.show').removeClass('show');
        $('html').removeClass('open-popup')
    }
});

let popup = $('.popup');
$('.js-close-popup').click(function (){
    popup.removeClass('show')
    $('html').removeClass('open-popup')
})

$('.js-open-popup').click(function (){
    let popupId = $(this).attr('data-popup-id'),
        popupEl = $(`#${popupId}`);
    if (popupEl) {
        setTimeout(function (){
            $('.dropdown.active').removeClass('active');
            dropdown.find('.dropdown-menu').removeClass('show');
            popupEl.addClass('show');
            $('html').addClass('open-popup')
        })
    }

})

$('.js-close-thank-you').click(function (){
    popup.removeClass('show')
    $('html').removeClass('open-popup')
    $('.popup__form__block').show(0);
    $('.popup__form__result').hide(0)
    $('#feedback-popup #feedback-text').val('');
})

$('#feedback-popup #send-feedback').on('click', function() {
    var formData = {
        feedback: $('#feedback-popup #feedback-text').val()
    };
    $('.feedback__row__error').hide(0)
    if (formData.feedback.length <= 3) {
        $('.feedback__row__error').show(0)
    } else {
        // Show loading animation 
        $('.popup__body').addClass('loading');
        // Add a CSS class for loading animation if not already defined
        if (!$('.popup__body').hasClass('animated-loader')) {
            $('.popup__body').append('<div class="loader"></div>');
        }
        $.ajax({
            headers: {
                'X-CSRF-TOKEN': $('#feedback-popup input[name=_token]').val()
            },
            url: '/feedback',
            method: 'POST',
            dataType: 'json',
            data: formData,
            success: function(response) {
                $('.popup__form__block').hide(0);
                $('.popup__form__result').show(0);
            },
            complete: function() {
                // Hide loading animation
                $('.popup__body').removeClass('loading');
                $('.loader').remove();
            }
        });
    }
});

let timeout;
$(document).on('click', '.shared', function (){
    clearTimeout(timeout)
    let link = $(this).attr('data-link')
    copyToClipboard(link)
    $('.link-copied').addClass('show')
    timeout = setTimeout(function (){
        $('.link-copied').removeClass('show')
    }, 5000)
})

function truncateToFit(container, text) {
    container.textContent = text;

    if (container.scrollWidth <= container.clientWidth) return;

    let startLength = Math.floor(text.length * 0.6);
    let endLength = text.length - startLength - 3;
    let start = text.slice(0, startLength);
    let end = text.slice(-endLength);
    let truncatedText = `${start}...${end}`;

    container.textContent = truncatedText;

    while (container.scrollWidth > container.clientWidth && start.length > 3) {
        start = start.slice(0, -1);
        end = end.slice(1);
        truncatedText = `${start}...${end}`;
        container.textContent = truncatedText;
    }
}

function applyTruncation() {
    document.querySelectorAll(".library__item-link__name").forEach(el => {
        const fullText = el.getAttribute("data-fullname") || el.textContent;
        el.setAttribute("data-fullname", fullText);
        truncateToFit(el, fullText);
    });
}

applyTruncation();
window.addEventListener("resize", applyTruncation);

function copyToClipboard(text) {
    var sampleTextarea = document.createElement("textarea");
    document.body.appendChild(sampleTextarea);
    sampleTextarea.value = text; //save main text in it
    sampleTextarea.select(); //select textarea contenrs
    document.execCommand("copy");
    document.body.removeChild(sampleTextarea);
}

let listElm = document.querySelector('.library .content__list'),
    app = document.querySelector('#app'),
    loadNow = false,
    currentPage = 1,
    canLoadMore = true;

let loadMore = function() {
    if (!loadNow && canLoadMore) {
        listElm.innerHTML += "<div class='load-more-spinner'><div></div><div></div><div></div><div></div></div>";
        loadNow = true;

        // Формируем корректную ссылку
        let queryString = new URLSearchParams(window.location.search);
        queryString.set('page', ++currentPage);
        let link = listElm.dataset.loadMore + '?' + queryString.toString();

        $.get(link, function(response) {
            $('.load-more-spinner').remove();
            
            // Обработка любого типа контента
            let items = [];
            let contentType = '';
            
            if (response.publications?.length > 0) {
                items = response.publications;
                contentType = 'publications';
            } else if (response.libraryMaterials?.length > 0) {
                items = response.libraryMaterials;
                
                contentType = 'library';
            } else if (Array.isArray(response.data)) {
                items = response.data;
                contentType = listElm.dataset.loadMore.includes('library') ? 'library' : 'publications';
            }

            if (items?.length > 0) {
                const colors = ['peach', 'pink', 'red', 'darkblue', 'blue', 'mint'];
                let fragment = document.createDocumentFragment();

                items.forEach(item => {
                    // Пропускаем, если элемент уже существует
                    if (document.querySelector(`[data-id="${item.id}"]`)) {
                        return;
                    }

                    // Базовые параметры
                    const isLibrary = contentType === 'library';
                    const route = `${window.location.origin}/${isLibrary ? 'library/detail/' : 'publications/'}${item.id}`;
                    item.color = item.color || colors[Math.floor(Math.random() * colors.length)];
                    
                    // Генерация типов контента
                    let typesElements = '';
                    (item.types || []).forEach(type => {
                        typesElements += `<div class="publication__type ${type}"></div>`;
                    });

                    let htmlItem = document.createElement('div');
                    htmlItem.classList.add('publication');
                    htmlItem.setAttribute('data-id', item.id);

                    // Формируем HTML в соответствии с common-card шаблоном
                    htmlItem.innerHTML = `
                        <div class="publication__top">
                            <a href="${route}" class="publication__image ${ item.image_orientation } color-${ item.color }">
                                <div class="publication__image__photo ${(isLibrary && item.types?.includes('VIDEO')) || !item.photo ? 'w-full' : ''}">
                                    <div class="publication__image__img">
                                        <div class="icon">
                                            <img src="${item.photo}" alt="logo" loading="lazy" onerror="imageHandleError(this, '${(item.types && item.types[0]) || 'FILE'}')"/>
                                        </div>
                                    </div> 
                              
                                   
                                </div>
                                <div class="publication__image__content">
                                    <div class="${item.locale === 'uk' ? 'publication__image__logo' : 'publication__image__logo__global'}"></div>
                                    <div class="publication__image__name">${item.author_names || ''}</div>
                                </div>
                            </a>
                            <div class="publication__actions">
                                <div class="publication__actions__item shared" data-link="${route}"></div>
                                <div class="publication__actions__item favorite"></div>
                            </div>
                        </div>
                        <div class="publication__info">
                            <div class="publication__tag ${contentType}">${item.genre_name || ''}</div>
                            <div class="publication__divider"></div>
                            <div class="publication__time">${item.created_at || ''}</div>
                            <div class="publication__divider"></div>
                            ${typesElements}
                            
                                <div class="tags theme-wrapper">
                                    <div class="theme first-tag tag">
                                        <a href="/search?q=${encodeURIComponent(item.theme)}" target="_blank">
                                            ${item.theme}
                                        </a>
                                    </div>
                        ${item.tags && item.tags.length > 0 ? `
                            ${item.tags.length > 1 ? `
                                <div class="tag hidden-tags">
                                    +${item.tags.length} тега
                                    <div class="tags-tooltip">
                                        ${item.tags.map(tag => `
                                            <div class="tag">
                                                <a href="/search?q=#${encodeURIComponent(tag)}" target="_blank">
                                                    ${tag}
                                                </a>
                                            </div>
                                        `).join('')}
                                    </div>
                                </div>
                            ` : `
                                <div class="tag">
                                    <a href="/search?q=#${encodeURIComponent(item.tags[0])}" target="_blank">
                                        ${item.tags[0]}
                                    </a>
                                </div>`}
                        ` : ''}
                        </div>
                        <a href="${route}" class="publication__name" title="${item.title}">
                            ${item.title}
                        </a>`;

                    fragment.appendChild(htmlItem);
                });

                listElm.appendChild(fragment);

                setTimeout(() => {
                    loadNow = false;
                }, 1000);
            } else {
                canLoadMore = false;
            }
        });
    }
};

// Detect when scrolled to bottom.
let scrollTimeout;
if (listElm) {
    app.addEventListener('scroll', function() {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
            let elem = document.querySelector('.library .content__list');
            if ((elem.offsetTop + elem.offsetHeight) <= (app.scrollTop + app.offsetHeight + 200)) {
                loadMore();
            }
        }, 200); // задержка для уменьшения частоты вызовов
    });
}


$('.themes-menu-form .form-row__field.checkbox').click(function (){
    setTimeout(()=>{
        $('.themes-menu-form button[type="submit"]').trigger('click');
    })
})
$('.themes-menu-form .form-row__field.radio').click(function (){
    setTimeout(()=>{
        $('.themes-menu-form button[type="submit"]').trigger('click');
    })
})


window.Alpine = Alpine;

Alpine.start();
